module.exports = __webpack_public_path__ + "static/media/trainer2 copy.735ca0b5.jpeg";